<template>
  <div>
    <div class="sub-header">Review your information</div>
    <div>
      <div class="inputs details">
        <div class="flex flex-col md:flex-row justify-between">
          <div>
            <div class="review-title">Name</div>
            <div
              class="review-info"
              data-test="donor-name"
            >
              {{ donorStore.donorInfo.prefix }} {{ donorStore.donorInfo.firstName }}
              {{ donorStore.donorInfo.lastName }} {{ donorStore.donorInfo.suffix }}
            </div>
          </div>
          <div v-if="donorStore.donorInfo.pronouns">
            <div class="review-title">Pronouns</div>
            <div
              class="review-info"
              data-test="donor-pronouns"
            >
              {{ donorStore.donorInfo.pronouns }}
            </div>
          </div>
        </div>
        <div class="review-title">Email</div>
        <div
          class="review-info"
          data-test="donor-email"
        >
          {{ donorStore.donorInfo.email }}
        </div>
        <div v-if="donorStore.donorInfo.homePhoneNumber">
          <div class="review-title">Phone</div>
          <div
            class="review-info"
            data-test="donor-phone"
          >
            {{ donorStore.donorInfo.homePhoneNumber }}
          </div>
        </div>
        <div v-if="donorStore.donorInfo.addressLine1">
          <div class="review-title">Address</div>
          <div class="review-info"></div>

          <div
            class="field"
            style="text-align: left"
            v-html="formattedAddress"
            data-test="donor-address"
          ></div>
        </div>
        <div v-if="(donorStore.donorPreferences?.categories?.selected || []).length > 0">
          <div class="review-title">Categories</div>
          <div class="flex flex-wrap">
            <div
              class="review-info"
              v-for="(category, index) in donorStore.donorPreferences.categories.selected"
              :key="index"
              data-test="donor-category"
            >
              {{ category.longValue
              }}<span v-if="index < donorStore.donorPreferences.categories.selected.length - 1">,&nbsp;</span>
            </div>
          </div>
        </div>

        <div v-if="(donorStore.donorPreferences?.orgSizes?.selected || []).length > 0">
          <div class="review-title">Organization Size</div>
          <div class="flex flex-wrap">
            <div
              class="review-info"
              v-for="(orgSize, index) in donorStore.donorPreferences.orgSizes.selected"
              :key="index"
              data-test="donor-org-size"
            >
              {{ orgSize.longValue
              }}<span v-if="index < donorStore.donorPreferences.orgSizes.selected.length - 1">,&nbsp;</span>
            </div>
          </div>
        </div>
        <div v-if="(donorStore.donorPreferences?.areasOfImpact?.selected || []).length > 0">
          <div class="review-title">Areas of Impact</div>
          <div class="flex flex-wrap">
            <div
              class="review-info"
              v-for="(areaOfImpact, index) in donorStore.donorPreferences.areasOfImpact.selected"
              :key="index"
              data-test="donor-area-of-impact"
            >
              {{ areaOfImpact.longValue
              }}<span v-if="index < donorStore.donorPreferences.areasOfImpact.selected.length - 1">,&nbsp;</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useDonorStore } from '@/stores/DonorStore.js';

const donorStore = useDonorStore();
const formattedAddress = computed(() => {
  donorStore.updateStateCode();

  let formattedAddress = donorStore.donorInfo.addressLine1 ? `${donorStore.donorInfo.addressLine1}, ` : '';

  if (donorStore.donorInfo.addressLine2) {
    formattedAddress += donorStore.donorInfo.addressLine2 ? `${donorStore.donorInfo.addressLine2} <br>` : '';
  }

  let city = donorStore.donorInfo.city ? `${donorStore.donorInfo.city}, ` : '';
  let stateCode = donorStore.stateCode ? `${donorStore.stateCode} ` : '';
  if (!stateCode) {
    stateCode = donorStore.donorInfo.stateOther ? `${donorStore.donorInfo.stateOther} ` : '';
  }
  let zip = donorStore.donorInfo.zip ? donorStore.donorInfo.zip : '';
  formattedAddress += `${city}${stateCode}${zip}`;

  return formattedAddress;
});
</script>
<style scoped>
.review-title {
  font-size: 12px;
  font-weight: 400;
}
.review-info {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 24px;
}
.details {
  text-align: left;
}
@media screen and (max-width: 768px) {
  .details {
    text-align: center;
  }
}
</style>
